import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Experience.css';
import { useLanguage } from '../../i18n/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
import { getExperiencesByIds } from '../../data/experienceData';

const ExperienceCard = ({ logo, position, company, items, period }) => (
  <div className="experience__card" data-name="Row">
    <div className="experience__card-header">
      <div className="experience__card-logo">
        <img src={logo} alt={company} />
      </div>
      <div className="experience__card-info">
        <h3 className="experience__card-title">{position}</h3>
        <ul className="experience__card-items">
          {items.map((item, index) => (
            <li key={index} className="experience__card-item">
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="experience__card-period">
        <p className="experience__card-period-text">{period}</p>
      </div>
    </div>
  </div>
);

const Experience = () => {
  const { t, language } = useLanguage();
  const { theme } = useTheme();
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    // Seleccionar experiencias específicas por ID para mostrar en landing
    // Puedes cambiar estos IDs para mostrar las experiencias que quieras
    const selectedExperiences = getExperiencesByIds([1, 2, 3, 4], language, theme);
    setExperiences(selectedExperiences);
  }, [language, theme]);

  return (
    <section className="experience" data-name="Experience" data-node-id="5:562">
      <div className="experience__content">
        <div className="experience__container" data-name="Container" data-node-id="5:563">
          {/* Header */}
          <div className="experience__header" data-name="Row" data-node-id="5:564">
            <div className="experience__header-inner" data-name="Row" data-node-id="5:565">
              <div className="experience__tag" data-name="Tag" data-node-id="5:566">
                <p className="experience__tag-text">{t('experience.tag')}</p>
              </div>
            </div>

            <div className="experience__header-subtitle" data-name="Row" data-node-id="5:567">
              <p className="experience__subtitle" data-node-id="5:568">
                {t('experience.subtitle')}
              </p>
            </div>
          </div>

          {/* Experience Cards */}
          <div className="experience__cards">
            {experiences.map((exp, index) => (
              <ExperienceCard
                key={exp.id}
                logo={exp.logo}
                position={exp.position}
                company={exp.company}
                items={exp.items}
                period={exp.period}
              />
            ))}
          </div>
        </div>

        {/* View All Button */}
        <div className="experience__footer">
          <Link to="/experience" className="experience__view-all">
            {t('experience.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Experience;
